import { useEffect, useMemo, useState } from 'react'
import debounce from 'debounce'
import set from 'lodash/set'
import warning from 'tiny-warning'
import { v4 as uuidv4 } from 'uuid'
import { FormOptions, FormValidation, FormContextType } from '../../Form/Form.types'
import { InputValidation } from '../useValidation'

// Hook

const useForm = ({ initialValues, onChange, onSubmit = () => {}, onMount = () => {} }: FormOptions) => {
    warning(initialValues, 'Form: no initial values defined. Please add a set of initial values {[name]: value}')

    const [formValues, setFormValues] = useState(initialValues)
    // const [validations, setValidations] = useState({})
    const [inputs, setInputs] = useState({})
    // const [pendingValidations, setPendingValidations] = useState([])

    const registerInput = (name: string, value: any, validation: InputValidation, options: any) => {
        const id = uuidv4()
        const _inputs = Object.assign(inputs)

        // warning(
        //     inputs[name],
        //     'This form context already includes an input with the name: ' +
        //         name +
        //         '. Input names per form context must be unique. Inputs:' +
        //         JSON.stringify(inputs),
        // )

        _inputs[name] = {
            id,
            options,
        }
        setInputs({ ..._inputs })

        if (value) {
            setValue(name, value)
        }

        // if (validation) {
        //     setValidation(name, validation)
        // }

        return id
    }

    const setValue = (name: string, value: any) => {
        // const _formValues = Object.assign(formValues)
        setFormValues((prevValue) => {
            // prevValue[name] = value
            set(prevValue, name, value)
            return { ...prevValue }
        })
        // handleChange(name, value)
    }

    const setValues = (values) => {
        // const _formValues = Object.assign(formValues)
        setFormValues(() => {
            return { ...values }
        })
        handleChange(null, values)
    }
    const setAllInputsDirty = () => {
        Object.keys(inputs).forEach((key) => {
            const input = inputs[key]
            const { options } = input
            if (options.setIsDirty) {
                options.setIsDirty(true)
            }
        })
    }

    const getInputs = () => {
        return inputs
    }

    // const setValidation = (name: string, validation: FormValidation) => {
    //     const _validations = Object.assign(validations)
    //     _validations[name] = validation
    //
    //     setValidations({ ..._validations })
    // }

    // const addPendingValidation = (name) => {
    //     const _pendingValidations = pendingValidations.slice()
    //     _pendingValidations.push(name)
    //     setPendingValidations(_pendingValidations)
    // }
    //
    // const removePendingValidation = (name) => {
    //     const _pendingValidations = pendingValidations.slice()
    //     _pendingValidations.filter((s) => s !== name)
    //     setPendingValidations(_pendingValidations)
    // }

    useEffect(() => {
        // Object.keys(validations).forEach((key) => {
        // const validation = validations[key]
        // })
        handleChange()
    }, [formValues])
    //
    // const validateOnChange = (name) => {
    //     return (e) => {}
    // }

    const handleSubmit = () => {
        const i = inputs
        setAllInputsDirty()
        if (onSubmit) {
            onSubmit(context)
        }
    }

    const context: FormContextType = {
        values: formValues,
        // inputs,
        getInputs,
        registerInput,
        setValue,
        setValues,
        // addPendingValidation,
        // removePendingValidation,
        submit: handleSubmit,
    }

    //Events
    const handleChange = (name?, value?) => {
        // debounce(validateOnChange(name), 500)
        if (onChange) {
            onChange(context, name, value)
        }
    }

    useEffect(() => {
        onMount(context)
    }, [])

    return context
}

export default useForm
